// import { MessageManagerWindow } from './MessageManagerWindow';
import { MessageManagerInMemory } from './MessageManagerInMemory';

// const isDevLocalhost = Boolean(
//   window.location.port !== '8080' &&
//     (window.location.hostname === 'localhost' ||
//       // [::1] is the IPv6 localhost address.
//       window.location.hostname === '[::1]' ||
//       // 127.0.0.1/8 is considered localhost for IPv4.
//       window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)),
// );
// export const declareMessenger = async (navigator) => {
//   if (!isDevLocalhost && navigator.serviceWorker) {
//     await navigator.serviceWorker.ready;
//     return new MessageManagerWindow({ sw: navigator.serviceWorker });
//   }
//   return new MessageManagerInMemory({});
// };

export const declareMessenger = () => new MessageManagerInMemory({});
